import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonDataModel } from '../common-data-model';
import { CommonService } from 'src/app-core/services/common.service';

@Component({
  selector: 'app-container-modifiers-labor-break-up',
  templateUrl: './container-modifiers-labor-break-up.component.html',
  styleUrls: ['./container-modifiers-labor-break-up.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ContainerModifiersLaborBreakUpComponent implements OnInit {
  commonDatamodel = new CommonDataModel();
  isFormLoading = false;
  containerId: number;
  labourCalculationbreakUps: any;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ContainerModifiersLaborBreakUpComponent>,
    private commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) public data: number) {
    this.containerId = data;
  }

  ngOnInit() {
    this.getModifiersLaborBreakUp();
  }

  getModifiersLaborBreakUp() {
    this.commonService.getModifiersBreakUp(this.containerId).subscribe(response => {
      this.labourCalculationbreakUps = response.data;
    });
  }

  onClose(): void {
    this.dialogRef.close(false);
  }
}
